import { useState } from 'react';

export function PrivacyWarningModal({ onContinue, onCancel }: { onContinue: () => void; onCancel: () => void }) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleContinue = () => {
    if (dontShowAgain) {
      localStorage.setItem('streambuddy_vision_privacy_warning_seen', 'true');
    }
    onContinue();
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[60]">
      <div className="bg-[#1a1a2e] border border-purple-500/30 rounded-2xl p-8 max-w-md mx-4 shadow-2xl animate-in fade-in zoom-in duration-200">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-purple-500/20">
            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <div>
            <h2 className="text-white font-bold text-xl">Privacy Check</h2>
            <p className="text-purple-300 text-sm font-medium">Screen Sharing Safety</p>
          </div>
        </div>

        <p className="text-gray-300 text-sm mb-6 leading-relaxed">
          The screen picker will display previews of <strong>all open windows and screens</strong>.
          <br /><br />
          If you are currently live streaming your entire desktop, these previews might be visible to your audience.
          <span className="block mt-2 text-purple-200/80 text-xs bg-purple-500/10 p-2 rounded border border-purple-500/20">
            Ensure you have hidden any sensitive content before proceeding.
          </span>
        </p>

        <div className="flex items-center gap-3 mb-6 bg-white/5 p-3 rounded-lg cursor-pointer hover:bg-white/10 transition-colors" onClick={() => setDontShowAgain(!dontShowAgain)}>
          <div className={`w-5 h-5 rounded border flex items-center justify-center transition-colors ${dontShowAgain ? 'bg-purple-600 border-purple-500' : 'border-gray-500'}`}>
            {dontShowAgain && <svg className="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>}
          </div>
          <span className="text-sm text-gray-400 select-none">Don't show this warning again</span>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 rounded-xl bg-white/5 hover:bg-white/10 text-gray-300 text-sm font-medium transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleContinue}
            className="flex-1 px-4 py-3 rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white text-sm font-bold transition-all shadow-lg hover:shadow-purple-500/25"
          >
            Continue to Picker
          </button>
        </div>
      </div>
    </div>
  );
}
